import dayjs from "dayjs";
import type { Edition } from "types";

export function oneEditionIsEnrolled(editions: Edition[] | undefined){
  let isAtLeastOneEditionEnrolled = editions?.some(edition =>  edition.status === "E");     

  return isAtLeastOneEditionEnrolled ?? false;
}

export function isDisabled(
  disabled:boolean,
  isEnrolled:boolean,
  isCompleted:boolean,
  hasAvailablePlaces:boolean,
  editionEndTime:dayjs.Dayjs
){
  if(isEnrolled) return false;
  if(isCompleted) return true;
  if(disabled) return true;
  if(!hasAvailablePlaces) return true;
  if(editionEndTime < dayjs()) return true;

  return false;
}


export function displayRadio(
  selfEnrollment:boolean, 
  oneEditionIsEnrolled:boolean,
  editMode:boolean
){
  if(!selfEnrollment) return "none";
  if(!oneEditionIsEnrolled && selfEnrollment) return "inline";
  if(editMode && selfEnrollment) return "inline";
  if(!editMode && selfEnrollment) return "none";
  if(editMode && !selfEnrollment) return "none";
}
